import { z } from "zod";

export const ConfigureCrmBodySchema = z.object({
  type: z.literal("swoogo").describe("CRM provider type"),
  externalId: z.string().min(1).describe("External event ID in the CRM system"),
  fieldMappings: z
    .object({
      status: z
        .string()
        .min(1)
        .describe(
          "Swoogo custom field ID for participant status (e.g. c_6949903)",
        )
        .optional(),
      bio: z
        .string()
        .min(1)
        .describe("Swoogo custom field ID for participant bio (e.g. c_6947268)")
        .optional(),
    })
    .describe("Maps Swoogo custom field IDs to participant fields")
    .nullable()
    .optional(),
  removalStatusValues: z
    .array(z.string().min(1))
    .min(1)
    .describe(
      'Status values that trigger participant removal (e.g. ["Declined", "Cancelled"])',
    )
    .nullable()
    .optional(),
  excludedExternalIds: z
    .array(z.string().min(1))
    .min(1)
    .describe("External IDs to exclude from participant creation")
    .nullable()
    .optional(),
  rotateSecret: z
    .boolean()
    .describe(
      "Whether to rotate the webhook secret. Ignored on first-time configuration (always creates). Defaults to false.",
    )
    .optional(),
});

export type ConfigureCrmBody = z.infer<typeof ConfigureCrmBodySchema>;

export const ConfigureCrmResultSchema = z.object({
  externalId: z.string().describe("External event ID in the CRM system"),
  secret: z
    .string()
    .nullable()
    .describe("Webhook secret (shown once). Null when secret was not rotated."),
});

export type ConfigureCrmResult = z.infer<typeof ConfigureCrmResultSchema>;
